import React from 'react';

// Import visual assets
import imgVisaStamping from '../../assets/images/image (2)add.png';
import imgDocAttest from '../../assets/images/image (3)add.png';
import imgCareerConsult from '../../assets/images/image (4)add.png';
import imgInterviewCoaching from '../../assets/images/image (5)add.png';
import imgResumePrep from '../../assets/images/image (6)add.png';

const OurAdditionalServices = () => {
  return (
    <section className="bg-[#EAF0F6] py-16 md:py-24 font-manrope">
      <div className="max-w-7xl mx-auto px-4 md:px-10 lg:px-8">
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 items-stretch">
          
          {/* Top Left Content Block (Spans 2 Columns on Large Screens) */}
          <div className="sm:col-span-2 flex flex-col justify-center pr-4 mb-6 lg:mb-0">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.15] mb-6">
              <span className="text-[#c1272d] block">Our Additional</span>
              <span className="text-[#0a1e3f] block mt-1">Services</span>
            </h2>
            <p className="text-[#5e6d7c] text-base md:text-lg leading-relaxed font-medium max-w-lg">
              Discover a wide range of value-added services, from document attestation to premium visa support, designed to make your overseas journey smoother, faster, and completely hassle-free.
            </p>
          </div>

          {/* Top Right - Service Card 1 */}
          <div className="relative h-72 sm:h-80 lg:h-auto min-h-[260px] rounded-[24px] overflow-hidden group cursor-pointer shadow-sm hover:shadow-lg transition-shadow duration-300">
            <img 
              src={imgVisaStamping} 
              alt="Visa Stamping Solutions" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(109,242,167,0)_45.47%,#302D48_100%)]"></div>
            <h3 className="absolute bottom-6 left-6 text-white font-extrabold text-lg md:text-xl leading-snug pr-6">
              Visa Stamping <br className="hidden md:block"/> Solutions
            </h3>
          </div>

          {/* Top Right - Service Card 2 */}
          <div className="relative h-72 sm:h-80 lg:h-auto min-h-[260px] rounded-[24px] overflow-hidden group cursor-pointer shadow-sm hover:shadow-lg transition-shadow duration-300">
            <img 
              src={imgDocAttest} 
              alt="Document Attestation" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(109,242,167,0)_45.47%,#302D48_100%)]"></div>
            <h3 className="absolute bottom-6 left-6 text-white font-extrabold text-lg md:text-xl leading-snug pr-6">
              Document <br className="hidden md:block"/> Attestation
            </h3>
          </div>

          {/* Bottom Row - Service Card 3 */}
          <div className="relative h-72 sm:h-80 rounded-[24px] overflow-hidden group cursor-pointer shadow-sm hover:shadow-lg transition-shadow duration-300">
            <img 
              src={imgCareerConsult} 
              alt="Career Consulting" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(109,242,167,0)_45.47%,#302D48_100%)]"></div>
            <h3 className="absolute bottom-6 left-6 text-white font-extrabold text-lg md:text-xl leading-snug pr-6">
              Career Consulting
            </h3>
          </div>

          {/* Bottom Row - Service Card 4 */}
          <div className="relative h-72 sm:h-80 rounded-[24px] overflow-hidden group cursor-pointer shadow-sm hover:shadow-lg transition-shadow duration-300">
            <img 
              src={imgResumePrep} 
              alt="Resume Preparation" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(109,242,167,0)_45.47%,#302D48_100%)]"></div>
            <h3 className="absolute bottom-6 left-6 text-white font-extrabold text-lg md:text-xl leading-snug pr-6">
              Resume Preparation
            </h3>
          </div>

          {/* Bottom Row - Service Card 5 */}
          <div className="relative h-72 sm:h-80 rounded-[24px] overflow-hidden group cursor-pointer shadow-sm hover:shadow-lg transition-shadow duration-300">
            <img 
              src={imgInterviewCoaching} 
              alt="Interview Coaching" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(109,242,167,0)_45.47%,#302D48_100%)]"></div>
            <h3 className="absolute bottom-6 left-6 text-white font-extrabold text-lg md:text-xl leading-snug pr-6">
              Interview Coaching
            </h3>
          </div>

          {/* Bottom Row - Card 6: CTA Box Block */}
          <div className="bg-[#2e6cb2] h-72 sm:h-80 rounded-[24px] p-8 flex flex-col justify-between shadow-sm hover:shadow-lg transition-all duration-300">
            <h3 className="text-white text-2xl md:text-[26px] font-bold leading-[1.3] tracking-tight pr-2">
              Explore Other solutions we offer
            </h3>
            <div>
              <button 
                onClick={() => window.location.href = '/ourcoreservices'}
                className="bg-[#c1272d] hover:bg-red-700 text-white text-xs tracking-widest font-bold py-3.5 px-6 shadow-md transition-all active:scale-95 uppercase whitespace-nowrap"
              >
                KNOW MORE
              </button>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default OurAdditionalServices;
